import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { EtatOnboarding } from './types';

// CONTRAT INVERSE de Services.ts : ces fonctions RE-LÈVENT au lieu de renvoyer [].
// Un appel qui échoue doit produire un état 'inconnu', jamais un « 0 voyageur »
// qui relancerait l'onboarding à un client qui en a cinq.

export const compterVoyageurs = async (userId: number): Promise<number> => {
  const reponse = await axios.get(`${API_BASE_URL}/voyageurs?userId=${userId}`);
  return Array.isArray(reponse.data) ? reponse.data.length : 0;
};

export const compterDemandes = async (userId: number): Promise<number> => {
  const reponse = await axios.get(`${API_BASE_URL}/demandes?userId=${userId}`);
  return Array.isArray(reponse.data) ? reponse.data.length : 0;
};

/**
 * Charge l'état d'avancement.
 * L'endpoint dédié n'existe qu'à partir du lot 2 : tant qu'il répond 404,
 * on retombe sur les deux compteurs, ce qui permet de déployer le front avant le back.
 */
export const chargerEtatOnboarding = async (userId: number): Promise<EtatOnboarding> => {
  try {
    const reponse = await axios.get(`${API_BASE_URL}/utilisateurs/${userId}/etat-onboarding`);
    const d = reponse.data || {};
    return {
      statut: 'ok',
      nbVoyageurs: Number(d.nbVoyageurs) || 0,
      nbDemandes: Number(d.nbDemandes) || 0,
      onboardingTermineLe: d.onboardingTermineLe ?? null,
      onboardingMasque: !!d.onboardingMasque,
      estSociete: !!d.estSociete,
    };
  } catch (erreur: any) {
    if (erreur?.response?.status !== 404) throw erreur;
    const [nbVoyageurs, nbDemandes] = await Promise.all([
      compterVoyageurs(userId),
      compterDemandes(userId),
    ]);
    return {
      statut: 'ok',
      nbVoyageurs,
      nbDemandes,
      // MODE DÉGRADÉ (backend pas encore déployé) : impossible de distinguer un
      // compte neuf d'un client de longue date, puisque la colonne n'existe pas.
      // On ne montre donc la feuille de route qu'à un compte STRICTEMENT vide.
      // Un client qui a déjà un voyageur est réputé onboardé : mieux vaut priver
      // un nouvel inscrit de la carte pendant la fenêtre de déploiement que
      // l'annoncer à quelqu'un qui utilise l'application depuis deux ans.
      onboardingTermineLe: nbVoyageurs > 0 ? 'inconnu' : null,
      onboardingMasque: false,
      estSociete: false,
    };
  }
};

export const majOnboarding = async (
  userId: number,
  patch: { masquer?: boolean; termine?: boolean }
): Promise<void> => {
  await axios.post(`${API_BASE_URL}/utilisateurs/${userId}/onboarding`, patch);
};
